import { create } from 'zustand';
import { TimerConfiguration } from '../../types/PlanningSessionType';

interface TimerStore {
  timerConfig: TimerConfiguration;
  setTimerConfig: (timerConfig: TimerConfiguration) => void;

  stopwatchData: {
    minutes: number;
    seconds: number;
  };
  setStopwatchData: (stopwatchData: { minutes: number; seconds: number }) => void;
}

export const defaultTimerConfig: TimerConfiguration = {
  duration: 10,
  createdAt: null,
  startedAt: null,
  status: 'paused',
  stoppedAt: null,
  totalSecondsPassed: null,
};

export const useTimerStore = create<TimerStore>((set) => ({
  timerConfig: defaultTimerConfig,
  setTimerConfig: (timerConfig) => set({ timerConfig }),

  stopwatchData: {
    minutes: 10,
    seconds: 0,
  },
  setStopwatchData: (stopwatchData) => set({ stopwatchData }),
}));
